import { AppBundle } from 'api/optimalprint-sdk.d';
import { Store } from 'store';
import getPrice from 'store/price/selector/getPrice';
import formatPrice from 'utils/price/formatPrice';
import sumPrices from 'utils/price/sumPrices';
import getSelectedBundleProducts from './getSelectedBundleProducts';

const getCurrentProductPrice = (store: Store) => {
  const { productId, quantity } = store.product;
  const { categoryId } = store.category;
  const { currencyId, priceFormat } = store.price;
  if (!productId || !categoryId || !quantity || !currencyId) return null;
  const productPrice = getPrice(store, categoryId, productId, quantity);

  const selectedBundledProductsPrice = getSelectedBundleProducts(store)
    .filter((selectedProduct) => selectedProduct.productId > 0)
    .map((selectedProduct) => getPrice(store, selectedProduct.categoryId, selectedProduct.productId, quantity)) as (
    | AppBundle.Api.Entity.Product.V1.IProductPrice
    | undefined
  )[];
  const price = sumPrices(productPrice, ...selectedBundledProductsPrice);
  if (!price) {
    return null;
  }
  const regularPrice = formatPrice(price.pi, priceFormat || '', currencyId);
  const discountedPrice = formatPrice(price.p, priceFormat || '', currencyId);

  return {
    regularPrice,
    discountedPrice,
  };
};

export default getCurrentProductPrice;
